import i18n from '../../../i18n'

export function toFlatSelectItem(item) {
  return {
    label: `${i18n.t('Common.FlatSelectListItemNumberPrefixKey')} ${item.number}`,
    number: item.number,
    value: item.id,
  }
}

export function toFlatWithBuildingSelectItem(item) {
  return {
    ...toFlatSelectItem(item),
    building: item.building,
  }
}

export function toFlatSelectItems(items, mapper = toFlatSelectItem) {
  return items.map(mapper)
}
